{
  "featuredEvent": "Featured Event",
  "upcomingEvents": "Upcoming Events",
  "rsvp": "RSVP",
  "dateAtTime": "{{date}} at {{time}}",
  "dateRange": "{{start}} - {{end}}"
}
